/**
 * AP-11 — Formatwahl nach Dateiendung, portiert aus `src/trace/TraceFormat.cpp`:
 * `.trc` → PEAK-artig, alles andere → Vector ASC.
 */

import type { CanFrame } from '../can/ICanAdapter';
import { createAscWriter, parseAscLine } from './AscCodec';
import { createTrcWriter, parseTrcLine } from './TrcCodec';
import type { TraceFormat, TraceLineParser, TraceWriter } from './types';

export function traceFormatOf(fileName: string): TraceFormat {
  return fileName.toLowerCase().endsWith('.trc') ? 'trc' : 'asc';
}

export function createTraceWriter(format: TraceFormat): TraceWriter {
  return format === 'trc' ? createTrcWriter() : createAscWriter();
}

export function traceLineParser(format: TraceFormat): TraceLineParser {
  return format === 'trc' ? parseTrcLine : parseAscLine;
}

/** Liest eine komplette Trace-Datei; unlesbare Zeilen werden übersprungen. */
export function parseTrace(text: string, format: TraceFormat): CanFrame[] {
  const parseLine = traceLineParser(format);
  const frames: CanFrame[] = [];
  for (const line of text.split('\n')) {
    const frame = parseLine(line.endsWith('\r') ? line.slice(0, -1) : line);
    if (frame !== null) frames.push(frame);
  }
  return frames;
}

/** Gegenstück zu `parseTrace()`; erzeugt Kopfzeilen + je eine Zeile pro Frame. */
export function encodeTrace(frames: readonly CanFrame[], format: TraceFormat, isRx = true): string {
  const writer = createTraceWriter(format);
  let out = writer.header();
  for (const frame of frames) out += writer.frame(frame, isRx);
  return out;
}
